export default __webpack_public_path__ + "static/exasperated-4853ebbd0a320d5c5ae62bc9433df5ad.svg";